import React from 'react';

const BankLogo = ({ size = 80 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Building structure */}
      <rect x="15" y="35" width="70" height="50" fill="#3b82f6" rx="2" />

      {/* Columns */}
      <rect x="20" y="40" width="8" height="40" fill="#ffffff" />
      <rect x="32" y="40" width="8" height="40" fill="#ffffff" />
      <rect x="44" y="40" width="8" height="40" fill="#ffffff" />
      <rect x="56" y="40" width="8" height="40" fill="#ffffff" />
      <rect x="68" y="40" width="8" height="40" fill="#ffffff" />

      {/* Roof/Triangle */}
      <path d="M50 15 L10 35 L90 35 Z" fill="#2563eb" />

      {/* Base */}
      <rect x="10" y="85" width="80" height="5" fill="#1e40af" rx="1" />

      {/* Dollar sign overlay */}
      <circle cx="50" cy="60" r="15" fill="#10b981" opacity="0.9" />
      <text
        x="50"
        y="68"
        fontSize="24"
        fontWeight="bold"
        fill="white"
        textAnchor="middle"
        fontFamily="Arial, sans-serif"
      >
        $
      </text>
    </svg>
  );
};

export default BankLogo;
